export default "__VITE_ASSET__B3BR3nAs__"